import _ from 'underscore';
import Promise from 'bluebird';
import { PreferencesSubadapter } from '@bingads-webui-campaign/preferences-subadapter';
import { serialize, deserialize } from './chart-preference-subadapter';

export class InlineChartPreferences {
  constructor(
    store,
    pathConfig,
    adapter,
    preferenceServicePromise
  ) {
    if (_.isUndefined(store.definitions.InlineChart)) {
      store.defineResource('InlineChart');

      // Attach a preferenceSubadapter to serialize and deserialize data
      adapter.registerSubadapter(
        'InlineChart',
        new PreferencesSubadapter({
          preferenceService: preferenceServicePromise,
          Resource: store.definitions.InlineChart,
          prefix: 'WebApp.CampaignUI.InlineChart',
          serialize,
          deserialize,
        })
      );
    }

    this.pathConfig = pathConfig;
    this.inlineChart = store.definitions.InlineChart;
  }

  /**
   * This function gets inline chart specific preference data, and returns
   * promise with resolved data. If key is injected as parameter, it will
   * return the speicific key value inside the inline chart preference
   * Otherwise, it returns all key/value pairs saved for inline charts.
   * @param {string} key to find in the inlinechart preference data
   * @param {string} project name under which preference will be stored
   * @returns {object} promise with set of key/values stored in preference
  */
  getInlineChartInfo(key = null, project = 'CampaignUI') {
    return this.inlineChart.findAll({
      where: { project },
    }).then((record) => {
      if (record.length === 0) {
        return Promise.resolve();
      }

      // Return the found record.
      const keyRecord = key ? record[0].inlineChartData[key] : record[0].inlineChartData;
      return Promise.resolve(keyRecord);
    });
  }

  /**
   * This function sets inline chart specific preference data, and returns
   * promise with resolved data. If provided key in passed parameter exists in preference
   * already, then it will update the value. Otherwise it will create a new key/value pair.
   * eg) setInlineChartInfo('{
   *   'Campaign-showChart': true,
   * }', 'CampaignUI')
   * @param {object} item that needs to be saved to perference store
   * @param {string} project name under which preference will be stored
   * @returns {object} key that is created/updated on preference service
   */
  setInlineChartInfo(item, project = 'CampaignUI') {
    return this.inlineChart.findAll({
      where: { project },
    }).then((record) => {
      if (record.length === 0) {
        // Create the new item.
        return this.inlineChart.create({ inlineChartData: item, project }, {
          path: this.pathConfig.get('odata.path'),
        });
      }

      const inlineChartInfo = _.result(record[0], 'inlineChartData');
      const newinlineChartInfo = _.extend({}, inlineChartInfo, item);

      return this.inlineChart.update(record[0].id, { inlineChartData: newinlineChartInfo });
    });
  }
}
